// This file is auto-generated during deployment - do not edit manually
export const buildInfo = {
  gitHash: 'c48826c', // Short git hash of the current commit
  releaseDate: '2026-09-04', // Date of the release
};
